<template>
  <b-card class="mb-3">
    <template #header>
      <div>
        <i class="fa fa-ellipsis-v mr-2 drag-handle"></i>
        <i class="icon-user"></i> <strong>General Information</strong>
      </div>
    </template>

    <b-form>
      <b-row>
        <b-col md="6">
          <b-form-group label="Username" label-for="username-component">
            <username
              id="username-component"
              :allowed="!hasPermission(UserNameChange)"
              :userid="userData.id"
              :user="userData.username"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="authUser.security === 1 || authUser.security === 5">
          <b-form-group label="Role">
            <role :user="userData.username" :current-role="userData.security_id" :key="userData.id"></role>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Email" label-for="email-component">
            <email
              id="email-component"
              :readonly="servers[userData.server].readonly || !hasPermission(UserIPsEmailView)"
              :allowed="!hasPermission(UserEmailChange)"
              :username="userData.username"
              :email="userData.email"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Discord Tag">
            <b-input-group>
              <b-input-group-prepend is-text><i class="fa fa-hashtag"></i></b-input-group-prepend>
              <b-form-input readonly :value="userData.discord_tag" />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Guild">
            <b-input-group>
              <b-input-group-prepend is-text><i class="fa fa-users"></i></b-input-group-prepend>
              <b-form-input readonly :value="userData.guild" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Membership Expiry">
            <b-input-group>
              <b-input-group-prepend is-text><i class="fa fa-star"></i></b-input-group-prepend>
              <b-form-input
                readonly
                :value="formatDateDisplay(userData.member_expire)"
                v-b-tooltip.hover.html="getDateTooltip(userData.member_expire)"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Money">
            <money
              :allowed="!hasPermission(UserMoneyChange)"
              :userid="userData.id"
              :price="userData.money"
              :server="userData.server"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Coins">
            <coins
              :allowed="!hasPermission(UserCoinChange)"
              :userid="userData.id"
              :coins="userData.coins"
              :server="userData.server"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Playtime">
            <b-input-group>
              <b-input-group-prepend is-text><i class="fa fa-gamepad"></i></b-input-group-prepend>
              <b-form-input readonly :value="convertMinsToHrsMins(userData.playtime)" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Registered">
            <b-input-group>
              <b-input-group-prepend is-text><i class="fa fa-calendar"></i></b-input-group-prepend>
              <b-form-input
                readonly
                :value="formatDateDisplay(userData.reg_date)"
                v-b-tooltip.hover.html="getDateTooltip(userData.reg_date)"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="Last Online">
            <b-input-group>
              <b-input-group-prepend is-text><i class="fa fa-clock-o"></i></b-input-group-prepend>
              <b-form-input
                readonly
                :value="formatDateDisplay(userData.last_active)"
                v-b-tooltip.hover.html="getDateTooltip(userData.last_active)"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import Username from '../Username'
import Email from '../Email'
import Coins from '../Coins'
import Money from '../Money'
import Role from '../Role'
import moment from 'moment'

export default {
  name: 'GeneralInfoCard',
  components: {
    Username,
    Email,
    Coins,
    Money,
    Role
  },
  props: {
    userData: { type: Object, required: true },
    authUser: { type: Object, required: true },
    servers: { type: Object, required: true }
  },
  methods: {
    convertMinsToHrsMins (mins) {
      if (!mins) return '0m'
      const h = Math.floor(mins / 60)
      const m = mins % 60
      let res = ''
      if (h > 0) res += `${h}h `
      res += `${m}m`
      return res
    },
    formatDateDisplay(val) {
        if (!val || val.startsWith('0001')) return '-';
        return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
    getDateTooltip(val) {
        if (!val || val.startsWith('0001')) return '';
        return moment(val).fromNow();
    }
  }
}
</script>
